import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

// AI-Hub (COPILOT_MASTER_PLAN subsystems D/E/H/R) — HITL review center,
// AI observability dashboard, and the live MAS plan graph. Client portal.

const AiApprovalsPage = lazy(() =>
  import('../pages/ai-hub/AiApprovalsPage').then((m) => ({ default: m.AiApprovalsPage })),
)
const AiActivityPage = lazy(() =>
  import('../pages/ai-hub/AiActivityPage').then((m) => ({ default: m.AiActivityPage })),
)

export const aiHubRoutes: RouteObject[] = [
  { path: '/ai-approvals', element: <AiApprovalsPage /> },
  { path: '/ai-activity', element: <AiActivityPage /> },
  // /ai-graph = the same observability page opened directly on the graph tab.
  { path: '/ai-graph', element: <AiActivityPage defaultTab="graph" /> },
]
